export type QuickAccessMenuComponentProps = {
    /** Příznak aktivního vyhledávání */
    isSearchActive: boolean;
};
